const watchSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    rows: 1,
    slidesPerRow: 1,
    // mobileFirst: true,
    responsive: [
        {
            breakpoint: 1720,
            settings: {
                slidesToShow: 3,
            }
        },
        {
            breakpoint: 1280,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3
            }
        },

        {
            breakpoint: 900,
            settings: {
                slidesToShow: 2
            }
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1
            }
        },
    ]

};

export default watchSettings;